var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tasks-wrapper",
    },
    [
      _vm.userIsTeacher
        ? _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#courseware-action-widget",
                name: "sidebar-actions",
              },
            },
            [
              _c("CoursewareTasksActionWidget", {
                attrs: {
                  taskGroup: _vm.taskGroup,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.taskGroup
        ? _c(
            "div",
            {
              staticClass: "cw-tasks-list",
            },
            [
              _c("CoursewareRibbon", {
                attrs: {
                  isContentBar: true,
                  showToolbarButton: false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "buttons",
                      fn: function fn() {
                        return [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "task-groups-index",
                                },
                              },
                            },
                            [
                              _c("StudipIcon", {
                                attrs: {
                                  shape: "category-task",
                                  size: 24,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "breadcrumbList",
                      fn: function fn() {
                        return [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "task-groups-index",
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Aufgaben")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(_vm._s(_vm.taskGroup.attributes["title"])),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  925598052
                ),
              }),
              _vm._v(" "),
              _c("TaskGroup", {
                attrs: {
                  taskGroup: _vm.taskGroup,
                  tasks: _vm.tasksByGroup[_vm.taskGroup.id],
                },
                on: {
                  "add-feedback": _vm.onShowAddFeedback,
                  "edit-feedback": _vm.onShowEditFeedback,
                  "solve-renewal": _vm.onShowSolveRenewal,
                },
              }),
            ],
            1
          )
        : !_vm.tasksLoading
        ? _c("CompanionBox", {
            attrs: {
              msgCompanion: _vm.$gettext(
                "Diese Courseware-Aufgabe konnte nicht gefunden werden."
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddFeedbackDialog
        ? _c("AddFeedbackDialog", {
            attrs: {
              content: _vm.currentDialogFeedback.attributes.content,
            },
            on: {
              create: _vm.createFeedback,
              close: _vm.closeDialogs,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditFeedbackDialog
        ? _c("EditFeedbackDialog", {
            attrs: {
              content: _vm.currentDialogFeedback.attributes.content,
            },
            on: {
              update: _vm.updateFeedback,
              close: _vm.closeDialogs,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.renewalTask
        ? _c("RenewalDialog", {
            attrs: {
              renewalDate: _vm.renewalDate,
              renewalState: _vm.renewalTask.attributes.renewal,
            },
            on: {
              update: _vm.updateRenewal,
              close: _vm.closeDialogs,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskGroupsAddSolversDialog
        ? _c("TaskGroupsAddSolversDialog", {
            attrs: {
              taskGroup: _vm.taskGroup,
            },
            on: {
              newtask: _vm.reloadTasks,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskGroupsDeleteDialog
        ? _c("TaskGroupsDeleteDialog", {
            attrs: {
              taskGroup: _vm.taskGroup,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskGroupsModifyDeadlineDialog
        ? _c("TaskGroupsModifyDeadlineDialog", {
            attrs: {
              taskGroup: _vm.taskGroup,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTasksDistributeDialog
        ? _c("CoursewareTasksDialogDistribute", {
            on: {
              newtask: _vm.reloadTasks,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }